export default function IndexSection() {
  const topics = [
    {
      title: '本周必看榜单',
      desc: '根据播放量和用户评分精选的当周最受欢迎影片，每周一准时更新。',
      count: 'TOP 10',
      img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20ranking%20visual%20with%20warm%20golden%20spotlight%20on%20film%20posters%2C%20elegant%20theater%20ambiance%2C%20dark%20background%20with%20amber%20highlights%2C%20clean%20minimal%20composition%2C%20no%20text&width=400&height=280&seq=index-1-weekly-top&orientation=landscape',
    },
    {
      title: '新片速递专区',
      desc: '国内外最新上映影片第一时间收录，高清片源持续更新中。',
      count: '每日更新',
      img: 'https://readdy.ai/api/search-image?query=Fresh%20movie%20premiere%20visual%20with%20elegant%20red%20carpet%20elements%2C%20warm%20theater%20lighting%2C%20cinematic%20atmosphere%2C%20dark%20background%20with%20golden%20accents%2C%20clean%20minimal%20composition%2C%20no%20text&width=400&height=280&seq=index-2-new-release&orientation=landscape',
    },
    {
      title: '高分神作合集',
      desc: '豆瓣8.0分以上的口碑佳作精选，影史经典与当代神作一网打尽。',
      count: '500+部',
      img: 'https://readdy.ai/api/search-image?query=Award%20winning%20film%20aesthetic%20with%20golden%20trophy%20and%20laurel%20wreath%20elements%2C%20warm%20premium%20lighting%2C%20elegant%20dark%20background%2C%20cinematic%20composition%2C%20no%20text%2C%20clean%20minimal%20style&width=400&height=280&seq=index-3-high-rated&orientation=landscape',
    },
    {
      title: '华语片精选',
      desc: '内地、港台优质华语电影与剧集，从经典到热播，支持国产佳作。',
      count: '1000+部',
      img: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20visual%20with%20traditional%20lantern%20and%20silk%20elements%2C%20warm%20golden%20evening%20glow%2C%20elegant%20artistic%20composition%2C%20dark%20rich%20background%2C%20no%20text%2C%20clean%20minimal%20style&width=400&height=280&seq=index-4-chinese-films&orientation=landscape',
    },
    {
      title: '日韩剧集追更',
      desc: '最热日韩剧集同步更新，字幕组精译，追剧日历一目了然。',
      count: '同步追更',
      img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20visual%20with%20romantic%20cityscape%20twilight%2C%20warm%20soft%20lighting%2C%20elegant%20modern%20aesthetic%2C%20cinematic%20composition%2C%20dark%20background%20with%20amber%20glow%2C%20no%20text%2C%20clean%20minimal%20style&width=400&height=280&seq=index-5-korean-drama&orientation=landscape',
    },
    {
      title: '动漫番剧天堂',
      desc: '日漫国漫全覆盖，经典重温与新番速递，二次元爱好者的精神角落。',
      count: '3000+集',
      img: 'https://readdy.ai/api/search-image?query=Anime%20style%20visual%20with%20vibrant%20colorful%20illustration%2C%20dreamy%20sunset%20sky%20with%20cherry%20blossoms%2C%20warm%20atmospheric%20lighting%2C%20artistic%20composition%2C%20clean%20minimal%20style%2C%20no%20text&width=400&height=280&seq=index-6-anime&orientation=landscape',
    },
    {
      title: '冷门佳作挖掘',
      desc: '那些被埋没的高分冷门电影与剧集，编辑精心挑选，发现意外惊喜。',
      count: '编辑精选',
      img: 'https://readdy.ai/api/search-image?query=Art%20house%20indie%20film%20visual%20with%20vintage%20projector%20and%20warm%20light%2C%20intimate%20cinema%20atmosphere%2C%20dark%20cozy%20background%20with%20soft%20amber%20glow%2C%20elegant%20composition%2C%20no%20text%2C%20clean%20minimal%20style&width=400&height=280&seq=index-7-hidden-gems&orientation=landscape',
    },
  ];

  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            主题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            七大精选主题，帮你快速定位想看的影视内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {topics.map((topic, i) => (
            <article
              key={i}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={topic.img}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent"></div>
                <span className="absolute top-3 right-3 px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full whitespace-nowrap">
                  {topic.count}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {topic.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {topic.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}